import { render, staticRenderFns } from "./ywyjx.vue?vue&type=template&id=7a30e82a&scoped=true&"
import script from "./ywyjx.vue?vue&type=script&lang=js&"
export * from "./ywyjx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a30e82a",
  null
  
)

export default component.exports